
import { useState, useEffect } from 'react';
import { getBlogPostImage } from '@/utils/image';
import { toast } from '@/hooks/use-toast';
import { getFallbackImage } from '@/utils/image';

export function useBlogImage(slug: string, category: string) {
  const [imageUrl, setImageUrl] = useState<string>(getFallbackImage(category));
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    
    const fetchImage = async () => {
      try {
        setLoading(true);
        setError(false);
        
        console.log(`Fetching image for slug: ${slug}, category: ${category}`);
        const url = await getBlogPostImage(slug, category);
        console.log(`Received image URL: ${url}`);
        
        if (isMounted) {
          setImageUrl(url);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error in useBlogImage:', err);
        if (isMounted) {
          setError(true);
          setLoading(false);
          
          // Already set initial state to fallback image
          // No need to set it again
          
          // Only show toast in development
          if (process.env.NODE_ENV === 'development') {
            toast({
              title: "Image loading error",
              description: "Using fallback image instead",
              variant: "destructive",
            });
          }
        }
      }
    };

    fetchImage();

    return () => {
      isMounted = false;
    };
  }, [slug, category]);

  return { imageUrl, loading, error };
}
